export default __webpack_public_path__ + "static/media/2022_05_23 - Puma0004_0109.b042e986.jpg";